import { Injectable } from '@angular/core';
import { ETSStorageService } from 'ets-fe-ng-sdk';

@Injectable({
  providedIn: 'root',
})
export class StorageService extends ETSStorageService {}
